import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/CloseOutlined"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/GetApp';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { 
    Container, 
    Modal, 
    IconButton
} from "@mui/material";
import datastore from "../../../store/hoa-datastore";
import config from "../../../hoa-config";
import { GenerateNewDocumentUrl } from "../../../utility/generate-new-document-url";
import { urlCheck } from "../../../utility/url-check";

export default function OverView(props:any) {
    const [open, setOpen] = useState(false);
    const [zips, setZips] = useState([]);
    const [name, setName] = useState('');
    const { details } = props;

    const onFileDOwnloadClick = async (url :string, folder: string) => {
        const newUrl = await GenerateNewDocumentUrl.getNewUrl(url, 'municipality', folder);
        if(newUrl && folder) {
            window.open(urlCheck(newUrl), '_blank');
        }else {
            window.open(urlCheck(url), '_blank');
        }
    }

    const onClose = () => {
        setOpen(!open);
    }

    const handleZipModal = (name: string, zips: any) => {
        setOpen(!open);
        setName(name);
        setZips(zips);
    }

    return (
        <div style={{ boxSizing: 'border-box' }}>
        {
            datastore.userRole != config.userRoles.OrganizationUser && (
                <div style={{ padding: '40px 24px', borderBottom: '1px solid #E8E8E8' }}>
                    <span className="overview-title-text">Basic information</span>
                    <div className='overview-basic-info-container'>
                        {
                            Object.keys(details.overView).map((title: any, index: number) => {
                                return (
                                    <div key={index} className="overview-basic-info-single">
                                        <span className="ov-title">{title}</span>
                                        <span className="ov-sub-title" style={{cursor: title === 'Zip' ? 'pointer' : ''}} onClick={title==="Zip" && details.overView[title].length>5 ? ()=>handleZipModal(details.municipalityName, details.overView[title]) : undefined}>
                                            {title == 'Zip' ? 
                                            `${details.overView[title].length>5 ? 
                                            `${details.overView[title].slice(0,5)}  +${details.overView[title].length-5} More` : details.overView[title]}` : 
                                            details.overView[title]}</span>
                                    </div>
                                )
                            })
                        }
                        <ZipModal
                            open={open}
                            onClose={onClose}
                            name={name}
                            zips={zips}
                        />
                    </div>
                </div>
            )
        }
            <div style={{ padding: '40px 24px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className="overview-title-text">Registration Information</span>
                    <span style={{ marginTop: '24px' }} className="ov-title">Tenant or Lease Registration Form</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', borderBottom: '1px solid #e8e8e8', paddingBottom: '24px' }}>
                        <div style={{display:"flex", flexDirection:"column"}}>
                        {
                            details.tenantLeaseRegistrationFormUrl?.length > 0 && details.tenantLeaseRegistrationFormUrl.map((url:any)=>{
                                return(
                                <div className="ov-pdf-container" onClick={()=>{onFileDOwnloadClick(url.url, 'resolutionForm')}} style={{cursor: url?.fileName ? "pointer" : "not-allowed"}}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <PictureAsPdfIcon style={{ width: '20px', height: '20px' }} />
                                        <span style={{ marginLeft: '14px' }} className="text-3E3E3E-14px">{url && url.fileName ? url.fileName : "N/A"}</span>
                                    </div>
                                    <DownloadIcon style={{ width: '20px', height: '20px', color: '#3576E5' }} />
                                </div>)
                            })
                        }
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '16px' }}>
                            <span className="text-787878-14px">Document Link</span>
                            {
                                details.registrationResolutionForm ?
                                <div onClick = {()=>{
                                    let url = details.registrationResolutionForm;
                                    if(url){
                                        if(!url.includes("http://") && !url.includes("https://")){
                                            url = "https://"+url;
                                        }
                                        window.open(url, '_blank')
                                    }
                                }}>
                                    <span className="text-3576E5-14px">Open Link</span>
                                    <IconButton>
                                        <OpenInNewIcon style={{ width: '20px', height: '20px', color: '#3576E5' }} />
                                    </IconButton>
                                </div>
                                : <div className="text-303030-16px" style={{marginTop:"12px"}}>N/A</div>
                            }
                        </div>
                    </div>

                    <span style={{ marginTop: '24px' }} className="ov-title">Registration Requirements</span>
                    <span style={{ maxWidth: '614px', wordBreak: 'break-all', marginTop: '8px' }} className="text-303030-14px">
                        {details.registrationRequirements}
                    </span>

                    <span style={{ marginTop: '24px' }} className="ov-title">Renewal Instructions</span>
                    <span style={{ maxWidth: '614px', wordBreak: 'break-all', marginTop: '8px', whiteSpace: 'pre-line' }} className="text-303030-14px">
                        {details.renewalInstructions}
                    </span>
                    {
                        datastore.userRole == config.userRoles.OrganizationUser && (
                            <>
                                <span style={{ marginTop: '24px' }} className="ov-title">Renewal Fee</span>
                                <span style={{ maxWidth: '614px', wordBreak: 'break-all', marginTop: '8px', whiteSpace: 'pre-line' }} className="text-303030-14px">
                                    {details.renewalFee ?  `$${details.renewalFee}` : ''}
                                </span>
                            </>
                        )
                    }

                    <span style={{ marginTop: '24px' }} className="ov-title">County's or Municipality's Renewal Form</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', paddingBottom: '24px' }}>
                        <div style={{display:"flex", flexDirection:"column"}}>
                        {
                            details.countyOrMunicipalityRenewalForm?.length > 0 && details.countyOrMunicipalityRenewalForm.map((url: any) => {
                                return(
                                <div className="ov-pdf-container" onClick={() => { onFileDOwnloadClick(url.url, 'renewalForm') }} style={{ cursor: url ?.fileName ? "pointer" : "not-allowed"}}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <PictureAsPdfIcon style={{ width: '20px', height: '20px' }} />
                                        <span style={{ marginLeft: '14px' }} className="text-3E3E3E-14px">{url && url.fileName ? url.fileName : "N/A"}</span>
                                    </div>
                                    <DownloadIcon style={{ width: '20px', height: '20px', color: '#3576E5' }} />
                                </div>)
                            })
                        }
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '16px' }}>
                            <span className="text-787878-14px">Document Link</span>
                            {
                                details.ownerRenewalForm ?
                                <div onClick = {()=>{
                                    let url = details.ownerRenewalForm;
                                    if(url){
                                        if(!url.includes("http://") && !url.includes("https://")){
                                            url = "https://"+url;
                                        }
                                        window.open(url, '_blank')
                                    }
                                }}>
                                    <span className="text-3576E5-14px">Open Link</span>
                                    <IconButton>
                                        <OpenInNewIcon style={{ width: '20px', height: '20px', color: '#3576E5' }} />
                                    </IconButton>
                                </div>
                                : <div className="text-303030-16px" style={{marginTop:"12px"}}>N/A</div>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

const ZipModal = ({zips, open, onClose, name}: any) => {
    return(
        <Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "450px",
					maxHeight: "645px",
					overflow: "auto",
					padding: "0px",
				}}
			>
				<div>
					<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', backgroundColor: '#EFF4FC', padding: '24px'}}>
                        <div>
                            <h3 style={{color: '#3E3E3E'}}>View Zip</h3>
                            <p>Showing all zip code for municipality-{name}</p>
                        </div>
						<IconButton
							onClick={() => onClose()}>
							<CloseIcon
								style={{cursor: "pointer"}}
							/>
						</IconButton>
					</div>
                    <div style={{padding: '24px'}}>
                        <span>Total Zip: {zips.length}</span>
                        <hr/>
                        {zips && zips.map((zip: any, index: number) => <span key={index}>{zip},</span>)}
                    </div>
				</div>
			</Container>
		</Modal>
    )
}